<div class="main-content">
  <ov-suite-hierarchy-tabs [tabs]="tabs"> </ov-suite-hierarchy-tabs>
  <div class="main-container">
    <ov-suite-hierarchy-table
      [title]="'Master Routes'"
      [formClass]="formClass"
      [excludeColumns]="1"
      [hasBulkUpload]="false"
    >
    </ov-suite-hierarchy-table>
  </div>
</div>
